import * as dateFns from 'date-fns';

export const currentYear = () => dateFns.getYear(new Date());

export const startOfYear = () => new Date(currentYear(), 0, 1);



// WEBPACK FOOTER //
// ./src/utils/date.js